import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { darken, rem } from 'polished';
import {
  FlexColCenter,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { ButtonWithRequest } from './ButtonWithRequest';
import { TableTd } from '../../Zemplin/General/Table';
import { CountSetter } from './CountSetter';
import { Watching } from './Watching';
import { DsiSvgIcon as SvgIcon, IconType } from '../General/SvgIcon';
import { formatPrice, round } from '../../../utilities';
import { SmallLoader } from '../General/SmallLoader';
import { __ } from 'react-i18n';

interface Props {
  price: string;
  isSale: number | boolean;
  oldPrice: string;
  salePercentage: string;
  addToRequest: any;
  addToCart: any;
  avail_id: number;
  ordered?: string;
  product: string;
  hasWatchdog?: boolean;
  hasFavourite?: boolean;
  currency: string;
  canOrder?: boolean;
  forbiddenOrder?: boolean;
  loadingPrices?: boolean;
  hasUser?: boolean;
  isNew?: boolean;
  isWaiting?: boolean;
  hiddenSale?: boolean;
  showCompareIcon?: boolean;
  isCompare?: boolean;
  addToCompare?: any;
}

function ProductPriceCartTable({
  price,
  addToCart,
  addToRequest,
  avail_id,
  isSale,
  oldPrice,
  salePercentage,
  ordered,
  product,
  hasFavourite = false,
  hasWatchdog = false,
  currency,
  canOrder,
  forbiddenOrder,
  loadingPrices,
  hasUser,
  isNew,
  isWaiting,
  hiddenSale,
  showCompareIcon,
  isCompare,
  addToCompare
}: Props) {
  const [count, setCount] = useState(1);

  const handleCountChange = newValue => {
    setCount(newValue);
  };
  return (
    <>
      {/* {!avail_id || avail_id === 11 || price === '0' || price === '0.0' */}
      {false ? (
        <>
          <PriceTableTd align={'right'}>
            <Soon>{__(`UŽ ČOSKORO`)}</Soon>
          </PriceTableTd>
          {/* <WatchingButtonTableTd colSpan={2}>
            <UnavailableWatching avail_id={avail_id} />
          </WatchingButtonTableTd> */}
        </>
      ) : (
        <>
          <PriceTableTd align={'right'}>
            <>
              {!!isSale ? (
                <OldPrice>
                  {formatPrice(parseFloat(oldPrice), currency)}
                  {` (-${round(salePercentage, 0)}%)`}
                </OldPrice>
              ) : hiddenSale?<OldPrice> {__("SUPER CENA")} </OldPrice>:null}
              {price && +price > 0 ? (
                formatPrice(parseFloat(price), currency, 2)
              ) : (
                <Soon>{__(`UŽ ČOSKORO`)}</Soon>
              )}
              {ordered && (
                <OrderedRow>
                  <SvgIcon
                    icon={IconType.cart}
                    fill={'#36BF91'}
                    width={16}
                    height={16}
                    marginRight={8}
                  />
                  <OrderedText>{`${__(
                    'Objednaných máte',
                  )} ${ordered} ks`}</OrderedText>
                </OrderedRow>
              )}
              {/* {loadingPrices && (
                <LoaderWrapper>
                  <SmallLoader
                    title={__('Prebieha načítanie cien')}
                    small={true}
                    primaryColor={true}
                  />
                </LoaderWrapper>
              )} */}
            </>
            {!!price && parseFloat(price) > 0 && !forbiddenOrder && (
              <MobileWraper>
                <ButtonWithRequest
                  onButtonClick={addToCart}
                  onRequestClick={addToRequest}
                  avail_id={avail_id}
                  // TODO zmenit ked bude dostupny porovnavac
                  hasDropdown={showCompareIcon}
                  product={product}
                  count={0}
                  hasFavourite={hasFavourite}
                  hasWatchdog={hasWatchdog}
                  canOrder={canOrder}
                  hasUser={hasUser}
                  isNew={isNew}
                  showCompareIcon={showCompareIcon}
                  isCompare={isCompare}
                  addToCompare={addToCompare}
                />
              </MobileWraper>
            )}
          </PriceTableTd>
          
          {canOrder && (
            <CountSetterTd>
              {price && +price > 0 && !forbiddenOrder ? (
                <CountSetter count={count} onChange={handleCountChange} />
              ) : null}
            </CountSetterTd>
          )}
          <ButtonTableTd>
            {price && +price > 0 && !forbiddenOrder ? (
              <ButtonWithRequest
                onButtonClick={addToCart}
                onRequestClick={addToRequest}
                avail_id={avail_id}
                // TODO zmenit ked bude dostupny porovnavac
                hasDropdown={showCompareIcon}
                product={product}
                count={count}
                hasFavourite={hasFavourite}
                hasWatchdog={hasWatchdog}
                canOrder={canOrder}
                hasUser={hasUser}
                isNew={isNew}
                isWaiting={isWaiting}
                showCompareIcon={showCompareIcon}
                isCompare={isCompare}
                addToCompare={addToCompare}
              />
            ) : null}
          </ButtonTableTd>
        </>
      )}
    </>
  );
}

const PriceTableTd = styled(TableTd)`
  padding: ${rem(16)};
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(20)};
  font-weight: 500;
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-right: ${rem(6)};
  white-space: nowrap;
  position: relative;

  ${({ theme }) => theme.mediab.m580`
      width: 100%;
  `}
`;

const LoaderWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

const MobileWraper = styled.div`
  display: none;

  ${({ theme }) => theme.mediab.m580`
      display: block;
      margin-top: ${rem(16)};
  `}
`;

const WatchingButtonTableTd = styled(TableTd)<{ width: number }>`
  padding: ${rem(16)} ${rem(16)} ${rem(16)} ${rem(8)};
  min-width: ${rem(260)};
`;

const ButtonTableTd = styled(TableTd)<{ width: number }>`
  padding: ${rem(16)} ${rem(16)} ${rem(16)} ${rem(8)};
  width: ${rem(82)};

  ${({ theme }) => theme.mediab.m580`
      display: none;
  `}
`;

const CountSetterTd = styled(TableTd)`
  width: ${rem(120)};
  padding-right: ${rem(8)};
  padding-left: ${rem(8)};

  ${({ theme }) => theme.mediab.m580`
      display: none;
  `}
`;

const OldPrice = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  color: #ff1e45eb;
  /* text-decoration: line-through; */
  letter-spacing: 0;
  font-weight: 400;

  ${({ theme }) => theme.mediab.l1050`
  `}
`;

const Soon = styled(TextP)`
  font-size: ${rem(16)};
  font-weight: 500;
  color: #cccccc;
`;

const OrderedRow = styled(FlexRowCenterVertical)``;

const OrderedText = styled(TextP)`
  font-weight: 400;
  font-size: ${rem(14)};
`;

const WatchingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  justify-content: flex-end;
`;

export { ProductPriceCartTable };
